import { createSelector } from 'reselect';

import { isIntegrationDesignerSupported } from '../../common-entities/integration/utils';

const _scopedState = (state) => state.entities.user.active;

const user = (state) => _scopedState(state);
const experienceAdminActions = (state) => _scopedState(state).experienceAdminActions;

const hasExperienceAdminActions = createSelector(
  [experienceAdminActions],
  (experienceAdminActions) => _.keys(_.filter(experienceAdminActions, (value, key) => value)).length > 0
);

const _userPermissions = (state) => _scopedState(state).permissions;

const timeZone = (state) => _scopedState(state).timeZone;

const canAdministerFeeds = (state) => _userPermissions(state).canAdministerFeeds;
const canAdministerCollections = (state) => _userPermissions(state).canAdministerCollections;
const canAdministerContent = (state) => _userPermissions(state).canAdministerContent;
const canExportContent = (state) => _userPermissions(state).canExportContent;
const canExportEntries = (state) => _userPermissions(state).canExportEntries;
const canExportWinners = (state) => _userPermissions(state).canExportWinners;
const canViewEntries = (state) => _userPermissions(state).canViewEntries;
const canViewIntegrationDebugDetails = (state) => _userPermissions(state).canViewIntegrationDebugDetails;
const canAccessIntegrationCredentials = (state) => _userPermissions(state).canAccessIntegrationCredentials;
const canAdministerLibrary = (state) => _userPermissions(state).canAdministerLibrary;
const canAdministerWinner = (state) => _userPermissions(state).canAdministerWinner;

//Integration specific access rights. These should be used over the model one as they can provide more context based on functionality needed. The ones in the user model are ment to be more pure and uncontextualised data.
const canAccessIntegrationList = (state) => _userPermissions(state).canAccessIntegrationList;
const canDeleteIntegration = (state) => _userPermissions(state).canDeleteIntegration;
const canEnableDisableIntegration = (state) => _userPermissions(state).canEnableDisableIntegration;
const canUpdateIntegration = (state) => _userPermissions(state).canUpdateIntegration;
const canCreateIntegration = (state) => _userPermissions(state).canCreateIntegration;
const canChangeIntegrationName = (state, integrationTypeRefId) =>
  _userPermissions(state).canChangeIntegrationName && //if user has access right to edit the name specifically
  isIntegrationDesignerSupported(integrationTypeRefId); //if the selected integration supports the IntegrationDesignerApp as it is the only place where the name can be updated

const canSwitchAccount = (state) => _userPermissions(state).canSwitchAccount;
const canViewExperiences = (state) => _userPermissions(state).canViewExperiences;
const canManageForms = (state) => _userPermissions(state).canManageForms;
const isAdmin = (state) => _userPermissions(state).isAdmin;
const isInsights = (state) => _userPermissions(state).isInsights;
const isCreator = (state) => _userPermissions(state).isCreator;
const isManager = (state) => _userPermissions(state).isManager;
const isPublisher = (state) => _userPermissions(state).isPublisher;
const isSupport = (state) => _userPermissions(state).isSupport;

//a unified access guard for Reward List
const canAccessRewardsList = (state) => _userPermissions(state).canAccessRewardsList;

const fullName = (state) => user(state).name;
const phone = (state) => user(state).phone;
const jobTitle = (state) => user(state).jobTitle;
const cheetahIdProfileUrl = (state) => user(state).cheetahIdProfileUrl;
const cessso = (state) => user(state).cessso;
const cesLastInvited = (state) => user(state).cesLastInvited;

export default {
  user,
  timeZone,
  canAdministerFeeds,
  canAdministerCollections,
  canAdministerWinner,
  canAdministerLibrary,
  fullName,
  phone,
  jobTitle,
  cheetahIdProfileUrl,
  cessso,
  cesLastInvited,

  canAccessIntegrationList,
  canDeleteIntegration,
  canEnableDisableIntegration,
  canUpdateIntegration,
  canChangeIntegrationName,
  canCreateIntegration,

  experienceAdminActions,
  hasExperienceAdminActions,
  canAdministerContent,
  canExportContent,
  canExportEntries,
  canExportWinners,
  canViewEntries,
  canViewIntegrationDebugDetails,
  canAccessIntegrationCredentials,
  canSwitchAccount,
  canViewExperiences,
  canManageForms,
  isAdmin,
  isInsights,
  isCreator,
  isManager,
  isPublisher,
  isSupport,

  canAccessRewardsList,
};
